import { render, staticRenderFns } from "./myclub.vue?vue&type=template&id=c883841c&scoped=true"
import script from "./myclub.vue?vue&type=script&lang=js"
export * from "./myclub.vue?vue&type=script&lang=js"
import style0 from "./myclub.vue?vue&type=style&index=0&id=c883841c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c883841c",
  null
  
)

export default component.exports